import {
  BaseBulkError,
  BaseMany,
  BaseOne,
  Route,
  TimeWindow,
} from '@cnx-saas/common';
import { FleetCapabilities } from '@cnx-saas/carrier-management';
import { Article, ArticleEmbedded } from './Article';
import { Location } from './Location';
import { Order } from './Order';

export enum LoadStatus {
  UNPLANNED = 'UNPLANNED',
  PRE_PLANNED = 'PRE_PLANNED',
  PLANNED = 'PLANNED',
  IN_ALLOCATION = 'IN_ALLOCATION',
  ALLOCATED = 'ALLOCATED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELAYED = 'DELAYED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
}

export const isLoadLocked = (status?: LoadStatus) =>
  status && status !== LoadStatus.UNPLANNED;

export type LoadArticle = {
  article: ArticleEmbedded;
  loadedQuantity: number;
};

export type LoadArticleInput = {
  article: ArticleEmbedded;
  loadedQuantity: number;
};

export type LoadLocation = {
  // id: string; // REMOVED:
  // locationId: string; // REMOVED:
  // locationVersion?: number; // REMOVED:
  location: Location;
  timeWindow: TimeWindow; // NOTE: { from: order.createdAt, to: order.deadline }
  order?: Order; // ADDED:
  articles?: LoadArticleInput[]; // ADDED:
};

export type LoadInput = {
  externalReference?: string; // RENAMED: customerReference
  content?: string;
  loadingMillimeter: number; // RENAMED: pallets
  weightInKg: number;
  pickUp: LoadLocation;
  dropOff: LoadLocation;
  transportRequirements?: FleetCapabilities[];
  additionalInfo?: string;
  // stackable?: boolean; // REMOVED:
  // articleNumber?: string; // REMOVED:
  articles?: LoadArticleInput[]; // ADDED:
};

export type Load = BaseOne &
  LoadInput & {
    tenantId: string;
    status: LoadStatus;
    statusChangedAt: Date;
    plannedFor?: Date;
    route?: Route;
  };

export type Loads = BaseMany<Load>;

export type LoadImport = {
  externalReference: string;
  loadingMeter?: number;
  weightInKg: number;
  pickUpLocationExternalReference: string;
  pickUpTimeWindowStart: Date;
  pickUpTimeWindowEnd: Date;
  dropOffLocationExternalReference: string;
  dropOffTimeWindowStart: Date;
  dropOffTimeWindowEnd: Date;
  articleExternalReference?: string;
  articleLoadedQuantity?: number;
  additionalInfo?: string;
  pallets?: number;
  palletsType?: string;
};

export type LoadInputWithTenantId = LoadInput & { tenantId: string };

export type LoadImportMapValidationResult = {
  loadsImportWithTenantId: LoadInputWithTenantId[];
  failedErrors: BaseBulkError[];
};
